/* Dependencies */
import { Product, SortBy } from '../../CoffeePicker.model';

/**
 * Format the products based on sort order.
 * @param products Array of product
 * @param sortOrder Order for products to be sorted into
 * @returns Sorted array of product
 */
export const getProductsWithSortOrder = (
  products: Product[],
  sortOrder: SortBy
): Product[] => {
  switch (sortOrder) {
    case 'Alphabetically, A-Z': {
      return sortProductsByTitleAscending(products);
    }

    case 'Alphabetically, Z-A': {
      return sortProductsByTitleDescending(products);
    }

    case 'Price, low to high': {
      return sortProductsByPriceAscending(products);
    }

    case 'Price, high to low': {
      return sortProductsByPriceDescending(products);
    }

    case 'Date, old to new': {
      return sortProductsByCreatedAscending(products);
    }

    case 'Date, new to old': {
      return sortProductsByCreatedDescending(products);
    }

    default: {
      return products;
    }
  }
};

/**
 *
 * @param products Array of product
 * @returns Given list of product sorted by title ascending
 */
function sortProductsByTitleAscending(products: Product[]): Product[] {
  return products.sort((a, b) => {
    if (a.title < b.title) {
      return -1;
    }
    if (a.title > b.title) {
      return 1;
    }
    return 0;
  });
}

/**
 *
 * @param products Array of product
 * @returns Given list of product sorted by title descending
 */
function sortProductsByTitleDescending(products: Product[]): Product[] {
  return products.sort((a, b) => {
    if (a.title > b.title) {
      return -1;
    }
    if (a.title < b.title) {
      return 1;
    }
    return 0;
  });
}

/**
 *
 * @param products Array of product
 * @returns Given list of product sorted by price ascending
 */
function sortProductsByPriceAscending(products: Product[]): Product[] {
  return products.sort((a, b) => {
    if (a.price < b.price) {
      return -1;
    }
    if (a.price > b.price) {
      return 1;
    }
    return 0;
  });
}

/**
 *
 * @param products Array of product
 * @returns Given list of product sorted by price descending
 */
function sortProductsByPriceDescending(products: Product[]): Product[] {
  return products.sort((a, b) => {
    if (a.price > b.price) {
      return -1;
    }
    if (a.price < b.price) {
      return 1;
    }
    return 0;
  });
}

/**
 *
 * @param products Array of product
 * @returns Given list of product sorted by created date ascending
 */
function sortProductsByCreatedAscending(products: Product[]): Product[] {
  return products.sort((a, b) => {
    if (a.dateAdded < b.dateAdded) {
      return -1;
    }
    if (a.dateAdded > b.dateAdded) {
      return 1;
    }
    return 0;
  });
}

/**
 *
 * @param products Array of product
 * @returns Given list of product sorted by created date descending
 */
function sortProductsByCreatedDescending(products: Product[]): Product[] {
  return products.sort((a, b) => {
    if (a.dateAdded > b.dateAdded) {
      return -1;
    }
    if (a.dateAdded < b.dateAdded) {
      return 1;
    }
    return 0;
  });
}
